import React from "react";
import {
  FaCompressArrowsAlt,
  FaExchangeAlt,
  FaGasPump,
  FaRoute,
  FaWater,
} from "react-icons/fa";

function FeaturesOfDEX() {
  return (
    <div className="services-style-two-area default-padding bg-gray blurry-shape-right-bottom">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="site-heading text-center">
              <h4 className="sub-title">What we do</h4>
              <h2 className="title split-text-right split-text-in-right">
                Key Features of a DEX Aggregator
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className=" fade-up-anim ">
          <div className="row">
            <div className="col-lg-4 col-md-6 process-two-single">
              <div className="services-style-two-item">
                <div className="top-info">
                  <div className="icon">
                    <FaRoute size={40} color="#2f6edb" />
                  </div>
                  <h4>
                    <a>Best Pricing with Smart Routing</a>
                  </h4>
                  <p>
                    DEX aggregators use algorithms to find the most efficient
                    route for trades. By splitting orders across multiple DEXs,
                    they secure the best possible rates, minimizing price
                    impact.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 process-two-single">
              <div className="services-style-two-item fade-up-anim">
                <div className="top-info">
                  <div className="icon">
                    <FaCompressArrowsAlt size={40} color="#2f6edb" />
                  </div>
                  <h4>
                    <a>Reduced Slippage</a>
                  </h4>
                  <p>
                    Aggregators help minimize slippage (the difference between
                    expected and actual prices) by pulling liquidity from
                    different sources to fulfill large orders more effectively.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 process-two-single">
              <div className="services-style-two-item fade-up-anim">
                <div className="top-info">
                  <div className="icon">
                    <FaGasPump size={40} color="#2f6edb" />
                  </div>
                  <h4>
                    <a>Gas Efficiency</a>
                  </h4>
                  <p>
                    Some aggregators optimize routes not only for price but also
                    to minimize gas fees, ensuring more cost-effective
                    transactions for users.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="brand-style-two-items">
              <div className="col-lg-4 col-md-6 process-two-single pt-4">
                <div className="services-style-two-item">
                  <div className="top-info">
                    <div className="icon">
                      <FaExchangeAlt size={40} color="#2f6edb" />
                    </div>
                    <h4>
                      <a>Cross-Chain Capabilities</a>
                    </h4>
                    <p>
                      Advanced DEX aggregators can operate across multiple
                      blockchain networks, allowing users to swap assets across
                      ecosystems, such as Ethereum, BNB Chain, and others.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 process-two-single pt-4">
                <div className="services-style-two-item fade-up-anim">
                  <div className="top-info">
                    <div className="icon">
                      <FaWater size={40} color="#2f6edb" />
                    </div>
                    <h4>
                      <a>Enhanced Liquidity</a>
                    </h4>
                    <p>
                      By aggregating liquidity from numerous DEXs, these
                      platforms provide deeper liquidity pools, making it easier
                      to complete larger trades without significant price
                      impact.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeaturesOfDEX;
